import {authHeader} from '../_helpers'
import axios from 'axios'
import jwt from 'jsonwebtoken'
import { store } from '../store'

export const userService = {
  login,
  logout,
  fetchUserData,
  searchUsers,
  getAllRoles,
  createUser,
  updateUser,
  deleteUser
}

function fetchUserData (user) {
  return axios.get(process.env.BASE_URL + '/api/user/' + user.id, config())
    .then(userDetails => {
      const currentUser = {
        id: user.id,
        username: user.username,
        role: user.role,
        token: user.token,
        customers: userDetails.data.customers
      }
      localStorage.setItem('user', JSON.stringify(currentUser))
      store.commit('setUser', currentUser)
    })
}

function login (username, password) {
  const requestOptions = {
    headers: {'Content-Type': 'application/json'}
  }

  const requestBody = JSON.stringify({'username': username, 'password': password})

  return axios.post(process.env.BASE_URL + '/login', requestBody, requestOptions)
    .then(handleLogin)
    .then(user => {
      if (user) {
        localStorage.setItem('user', JSON.stringify(user))

        this.fetchUserData(user)
          .then(() => store.dispatch('showNotification', {
            title: 'Herzlich Willkommen',
            type: 'primary'
          }))
          .catch(error => console.log(error))
      }
    })
}

function logout () {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
  store.commit('setUser', null)
}

function searchUsers (searchTerms, page, size) {
  if (page !== undefined && size !== undefined) {
    return axios.post(process.env.BASE_URL + '/api/user/search?page=' + page + '&size=' + size, searchTerms, config())
  } else {
    return axios.post(process.env.BASE_URL + '/api/user/search', searchTerms, config())
  }
}

function getAllRoles () {
  return axios.get(process.env.BASE_URL + '/api/role', config())
}

function createUser (userForm) {
  const newUser = {
    email: userForm.email,
    password: userForm.password,
    pwIsInitial: true,
    role: userForm.role,
    customers: userForm.customers,
    firstName: userForm.firstName,
    lastName: userForm.lastName,
    street: userForm.street,
    city: userForm.city,
    zipCode: userForm.zipCode
  }

  return axios.post(process.env.BASE_URL + '/api/user', newUser, config())
}

function updateUser (user) {
  const newUser = {
    id: user.id,
    email: user.email,
    password: user.password,
    pwIsInitial: user.password !== null,
    role: user.role,
    customers: user.customers,
    firstName: user.firstName,
    lastName: user.lastName,
    street: user.street,
    city: user.city,
    zipCode: user.zipCode
  }
  return axios.put(process.env.BASE_URL + '/api/user/' + newUser.id, newUser, config())
}

function deleteUser (id) {
  return axios.delete(process.env.BASE_URL + '/api/user/' + id, config())
}

function handleLogin (response) {
  if (response.status !== 200) {
    if (response.status === 401) {
      logout()
      location.reload(true)
    }
  }
  if (response.headers.authorization) {
    const bearer = response.headers.authorization
    const token = bearer.substring(7, bearer.length)
    const decoded = jwt.decode(token)

    return {'id': decoded.userId, 'username': decoded.sub, 'role': decoded.role.replace(/ROLE_/g, ''), 'token': token}
  }
}

function config () {
  return {headers: authHeader()}
}



// WEBPACK FOOTER //
// ./src/_services/user-service.js